import { Controller } from '@hotwired/stimulus';

export default class StudentSearchTerms extends Controller {
  static targets = [
    'frame',
    'form'
  ];

  selectionChanged() {
    const url      = new URL(location.href);
    const formData = new FormData(this.formTarget);
    url.search     = new URLSearchParams(formData).toString();

    this.frameTarget.src = url.href;
    this.frameTarget.reload();
  }
}
